import React, { Component, Fragment } from 'react';

import './style.scss';

export default class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: require('./data.js'),
        };
    }
    render() {
        const { data } = this.state;
        return (
            <Fragment>
                <ul className="split contact">
                    <li>
                        <div className="wrapper">{data.content.left()}</div>
                    </li>
                    <li>
                        <div className="wrapper">{data.content.right()}</div>
                    </li>
                </ul>
                <div className="clear"></div>
            </Fragment>
        );
    }
}
